import { useMemo } from 'react'

import { useAirbridgeContext } from '@/shared/config'
import { isNilOrEmptyString, useFormatDate } from '@/shared/lib'

type Props = {
  startDate?: string
  endDate?: string
}

export const useDateRange = ({ startDate, endDate }: Props) => {
  const airbridge = useAirbridgeContext()
  const { formatDate } = useFormatDate()

  const dateRange = useMemo(() => {
    if (isNilOrEmptyString(startDate) || isNilOrEmptyString(endDate)) return ''

    return `${formatDate({ date: startDate, format: 'MM.dd' })} - ${formatDate({ date: endDate, format: 'MM.dd' })}`
  }, [startDate, endDate])

  const handleDateInputClick = () => {
    airbridge.openDeeplink()
  }

  return {
    dateRange,
    handleDateInputClick,
  }
}
